import { Checkbox, Stack, Switch, Typography } from "@mui/material";
import { useRef, useState } from "react";
import { Controller } from "react-hook-form";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import CustomDialog from "../CustomDialog";
import NullCheck from "components/NullCheck";

const SwitchInput = ({
  control,
  title,
  name,
  disabled,
  required,
  errors,
  defaultChecked,
  onChanged,
  leftTitle
}) => {
  const refInput = useRef(null);
  const { bt } = useBizTypeTranslation();
  const [openMassge, setOpenMassge] = useState(false);
  const massge = errors ? errors[name]?.message : "";

  return (
    <Stack alignItems="center" direction="row" >

      <NullCheck valueForCheck={leftTitle}>
        <Typography fontWeight="bold" fontSize={14}>
          {`${required ? "*" : ""}${bt(title)}`}
        </Typography>
      </NullCheck>

      <Controller
        name={name}
        control={control}
        defaultValue={defaultChecked}
        rules={{
          required: required ? bt("REQUIRED") : false,
        }}
        render={({ field: { onChange, value } }) => (
          <Switch
            defaultValue={defaultChecked}
            inputRef={refInput}
            disabled={disabled}
            checked={value ? value : defaultChecked ? defaultChecked : false}
            value={value ?? false}
            onChange={(e) => {
              onChange(e)
              onChanged && onChanged(e.target.value)
            }}
          />
        )}
      />

      <NullCheck valueForCheck={!leftTitle}>
        <Typography fontWeight="bold" fontSize={14}>
          {`${required ? "*" : ""}${bt(title)}`}
        </Typography>
      </NullCheck>

      <NullCheck valueForCheck={massge}>
        <CustomDialog
          title="ERROR"
          open={openMassge}
          width={300}
          onClose={() => setOpenMassge(false)}
          closeBtn="CLOSE"
        >
          <Stack alignItems="center">
            {massge}
          </Stack>
        </CustomDialog>
      </NullCheck>
    </Stack>
  );
};
export default SwitchInput;
